import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { OverridableStringUnion } from '@mui/types';
import styled from 'styled-components';

import { COLOR } from '@/globalStyles';
import { formatStringDatesToPeriod } from '@/utils/date/date';

type RequestPeriodProps = {
    className?: string;
    from: string;
    to: string;
    textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
};

const RequestPeriod = ({ className, from, to, textVariant = 'table_text' }: RequestPeriodProps) => {
    return (
        <div className={className}>
            <InsertInvitationOutlinedIcon sx={{ color: COLOR.zambezi }} />
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {formatStringDatesToPeriod(from, to)}
            </Typography>
        </div>
    );
};

const Styled = styled(RequestPeriod)``;
export default Styled;
